import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Clock, LogOut, Mail, ShieldAlert, XCircle } from 'lucide-react';

export default function PendingApproval() {
  const { user, logout } = useAuth();

  const isRejected = user?.status === 'rejected';
  const isDisabled = user?.is_active === false;

  let title = 'Your account is awaiting administrator approval.';
  let message = 'Please contact your administrator to gain access.';
  let Icon = Clock;
  let iconClass = 'text-amber-600 bg-amber-100';

  if (isRejected) {
    title = 'Your account has been rejected.';
    message = 'Please contact your administrator if you believe this is a mistake.';
    Icon = XCircle;
    iconClass = 'text-red-600 bg-red-100';
  } else if (isDisabled) {
    title = 'Your account has been disabled.';
    message = 'Please contact your administrator to re-enable access.';
    Icon = ShieldAlert;
    iconClass = 'text-slate-600 bg-slate-200';
  }

  const handleLogout = async () => {
    await logout();
    window.location.href = '/login';
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center bg-slate-50 p-4"
      data-testid="pending-approval-page"
    >
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl shadow-sm p-8 text-center">
        <div className={`w-16 h-16 ${iconClass} rounded-full flex items-center justify-center mx-auto mb-5`}>
          <Icon className="w-8 h-8" />
        </div>

        <h1 className="text-2xl font-bold text-slate-900" data-testid="pending-title">
          {title}
        </h1>
        <p className="text-slate-600 mt-3" data-testid="pending-message">
          {message}
        </p>

        {user && (
          <div className="mt-6 bg-slate-50 border border-slate-200 rounded-lg p-4 text-left">
            <div className="flex items-center gap-3">
              {user.picture ? (
                <img src={user.picture} alt="" className="w-10 h-10 rounded-full" />
              ) : (
                <div className="w-10 h-10 rounded-full bg-slate-200 flex items-center justify-center">
                  <Mail className="w-5 h-5 text-slate-500" />
                </div>
              )}
              <div className="min-w-0">
                <p className="text-sm font-medium text-slate-900 truncate">{user.name}</p>
                <p className="text-xs text-slate-500 truncate">{user.email}</p>
              </div>
            </div>
          </div>
        )}

        <Button
          onClick={handleLogout}
          variant="outline"
          className="mt-6 w-full gap-2"
          data-testid="pending-logout-btn"
        >
          <LogOut className="w-4 h-4" />
          Sign out
        </Button>

        <p className="text-xs text-slate-400 mt-4">
          If you were just approved, sign out and sign in again to refresh your access.
        </p>
      </div>
    </div>
  );
}
